import { styled } from 'styled-components';

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const SliderContainer = styled.div`
  width: 100%;

  .swiper-slide {
    width: auto;
  }
`;
const NavigationContainer = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    position: absolute;
    top: 50%;
    left: -20px;
    right: -20px;
    justify-content: space-between;
    transform: translateY(-50%);
    z-index: 10;
    pointer-events: none;
  }

  @media (min-width: 768px) and (max-width: 1240px) {
    left: 4px;
    right: 4px;
  }
`;
const NavigationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #27262b;
  cursor: pointer;
  transition: all 0.2s;
  border: 0;
  pointer-events: auto;

  &:hover {
    transform: scale(1.05);
  }

  &.swiper-button-disabled {
    opacity: 0.2;
    pointer-events: none;
  }

  &::after {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    background-image: ${(props) =>
      props.$dir === 'prev'
        ? 'url(/images/icons/arrow-right-white.svg)'
        : 'url(/images/icons/arrow-left-white.svg)'};
    background-repeat: no-repeat;
    background-position: center center;
  }
`;

export { SliderWrapper, SliderContainer, NavigationContainer, NavigationButton };
